import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { MessageSquare, X } from 'lucide-react';
import { Container, SectionHeading, fadeInUp } from './shared';

const DiscoverySection: React.FC = () => {
  const { t } = useTranslation();
  const notNeeded = t('landing.discovery.notNeeded', { returnObjects: true }) as string[];

  return (
    <section className="relative py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute left-[-10%] top-1/2 h-[400px] w-[500px] -translate-y-1/2 rounded-full bg-brand-secondary/10 blur-[120px]" />
      </div>

      <Container className="relative grid gap-16 lg:grid-cols-2 lg:items-center lg:gap-20">
        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
          className="glass-card mx-auto w-full max-w-md rounded-3xl p-8"
        >
          <div className="mb-6 flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-button">
              <MessageSquare className="h-5 w-5 text-white" />
            </div>
            <span className="font-semibold text-white">{t('landing.discovery.agentLabel')}</span>
          </div>
          <div className="space-y-3">
            <div className="ml-auto max-w-[80%] rounded-2xl rounded-tr-sm bg-white/[0.06] px-4 py-3 text-sm text-white/90">
              {t('landing.discovery.chat.msg1')}
            </div>
            <div className="max-w-[85%] rounded-2xl rounded-tl-sm bg-brand-button px-4 py-3 text-sm text-white">
              {t('landing.discovery.chat.msg2')}
            </div>
            <div className="ml-auto max-w-[80%] rounded-2xl rounded-tr-sm bg-white/[0.06] px-4 py-3 text-sm text-white/90">
              {t('landing.discovery.chat.msg3')}
            </div>
          </div>
        </motion.div>

        <div>
          <SectionHeading
            align="left"
            eyebrow={t('landing.discovery.eyebrow')}
            title={t('landing.discovery.title')}
            subtitle={t('landing.discovery.subtitle')}
          />

          <div className="mt-8 flex flex-col gap-3">
            {notNeeded.map((item, i) => (
              <motion.div
                key={item}
                variants={fadeInUp}
                custom={i + 2}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                className="flex items-center gap-3 text-brand-muted"
              >
                <X className="h-4 w-4 flex-shrink-0 text-white/30" />
                <span>{item}</span>
              </motion.div>
            ))}
          </div>

          <motion.div
            variants={fadeInUp}
            custom={5}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            className="mt-8 rounded-2xl border border-white/[0.08] bg-white/[0.04] p-6 backdrop-blur-xl"
          >
            <p className="font-semibold text-white">{t('landing.discovery.outcome')}</p>
          </motion.div>
        </div>
      </Container>
    </section>
  );
};

export default DiscoverySection;
